/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography, Button } from "@material-ui/core";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  postrequirementButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
    [theme.breakpoints.only("md")]: {
      width: "100%",
      margin: "0rem 0rem 0.5rem 0rem",
    },
    [theme.breakpoints.only("sm")]: {
      width: "100%",
      margin: "0rem 0rem 0.5rem 0rem",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      margin: "0rem 0rem 0.5rem 0rem",
    },
    margin: "0rem 0.25rem 0rem 0rem",
    backgroundColor: "#FFFFFF",
    color: "#202020",
    textTransform: "capitalize",
  },
  contactButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
    [theme.breakpoints.only("md")]: {
      width: "100%",
      margin: "0rem",
    },
    [theme.breakpoints.only("sm")]: {
      width: "100%",
      margin: "0rem",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      margin: "0rem",
    },
    margin: "0rem 0rem 0rem 0.25rem",
    background: "-webkit-linear-gradient(0deg, #F74134, #EB1C61)",
    color: "#FFFFFF",
    textTransform: "capitalize",
  },
  buttonText: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: "1.3125rem",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.only("md")]: {
      flexDirection: "column",
    },
    [theme.breakpoints.only("sm")]: {
      flexDirection: "column",
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
}));

const PostRequirementButtons = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.buttonContainer}>
        <Button
          component="button"
          variant="contained"
          size="large"
          className={classes.postrequirementButton}
          href="/postrequirement"
        >
          <Typography
            variant="body2"
            component="span"
            className={classes.buttonText}
          >
            Post Requirement
          </Typography>
        </Button>
        <Button
          component="button"
          variant="contained"
          size="large"
          className={classes.contactButton}
          href="/company/contact-us"
        >
          <Typography
            variant="body2"
            component="span"
            className={classes.buttonText}
          >
            Contact Us
          </Typography>
        </Button>
      </div>
    </React.Fragment>
  );
};

export default PostRequirementButtons;
